/**
 * Reports feature auto-registration and exports.
 *
 * Practice reports engine: run code-defined reports (payroll, attendance),
 * group/export results, and save named views for quick reruns.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { reportsFeature } from './store/feature';

autoRegisterFeature(reportsFeature);

export * from './components';
export * from './hooks/useReportsAccess';
export * from './store';
export * from './types';
